import React from 'react';
import LeaderCoachingReport from './leader-coaching-report';
import LeaderDevelopmentReport from './leader-development-report';
import LeaderManagerReport from './leader-manager-report';

export const LEADERSHIP_COACHING = 1;
export const LEADERSHIP_DEVELOPMENT = 2;
export const LEADERSHIP_MANAGER = 3;

function LeaderReports({ reportSelection, candidate, creatingPdf }) {
  return (
    <>
      {reportSelection === LEADERSHIP_COACHING && (
        <LeaderCoachingReport candidate={candidate} creatingPdf={creatingPdf} />
      )}
      {reportSelection === LEADERSHIP_DEVELOPMENT && (
        <LeaderDevelopmentReport candidate={candidate} creatingPdf={creatingPdf} />
      )}
      {reportSelection === LEADERSHIP_MANAGER && (
        <LeaderManagerReport candidate={candidate} creatingPdf={creatingPdf} />
      )}
    </>
  );
}

export default LeaderReports;
